import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routeList: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('../layout/indexPage.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue'),
        meta: {
          title: '首页',
        }
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/product/detailPage.vue'),
        meta: {
          title: '产品详情',
        }
      },
      {
        path: '/product/:dataId',
        name: 'productDetail',
        component: () => import('../views/product/detailPage.vue'),
        meta: {
          title: '产品详情',
        }
      },
      {
        path: '/testPage',
        name: 'testPage',
        component: () => import('../views/testPage.vue'),
        meta: {
          title: '产品详情',
        }
      },
      {
        path: '/drone',
        name: 'drone',
        component: () => import('../views/DroneShowcase/index.vue'),
        meta: {
          title: 'X-2000 Drone',
        }
      },

      {
        path: '/babiyunlian',
        name: 'babiyunlian',
        component: () => import('../views/BabiYunlian/index.vue'),
        meta: {
          title: '八比云链',
        }
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routeList,

})
export default router